module.exports = __webpack_public_path__ + "static/media/hero-bcg6.3e164f7e.jpg";